export default __webpack_public_path__ + "static/media/mouse right click.cd0b0125.svg";